import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

export type StatusFinanceiro = 'TODOS' | 'LIBERADO' | 'BLOQUEADO' | 'ERRO';
export interface LiberacoesFiltro {
  dataInicio: string;
  dataFim: string;
  status: StatusFinanceiro;
  pagina: number;
  tamanhoPagina: number;
}
export interface LiberacoesLista extends LiberacoesFiltro {
  resumo: {
    totalPedidos: number; liberados: number; bloqueados: number; erros: number;
    percentualLiberados: number; percentualBloqueados: number; percentualErros: number;
  };
  pedidos: {
    logId: number; orderId: number; numeroPedido: number | null; numeroPedidoErp: string;
    cliente: string; vendedor: string; dataHoraUtc: string; status: Exclude<StatusFinanceiro, 'TODOS'>;
    observacoes: string;
  }[];
}

export function podeVerLiberacoesFinanceiro(guid: string, financeiro: boolean, diretor: boolean): boolean {
  return (guid || '').toUpperCase() === 'A65C9C67-A1F9-470E-9534-17FB0E6CC516' && (financeiro || diretor);
}

export function acessoLocalLiberacoesFinanceiro(): boolean {
  const flag = (name: string) => ['true', '1'].includes(localStorage.getItem(name));
  return podeVerLiberacoesFinanceiro(localStorage.getItem('guidclientenapis'), flag('is_financeiro'), flag('is_diretor'));
}

export function hojeBrasilia(agora = new Date()): string {
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(agora);
  const parte = (tipo: string) => partes.find(p => p.type === tipo).value;
  return `${parte('year')}-${parte('month')}-${parte('day')}`;
}

@Injectable({ providedIn: 'root' })
export class DashboardLiberacoesFinanceiroService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}
  listar(filtro: LiberacoesFiltro) {
    const params = new HttpParams()
      .set('dataInicio', filtro.dataInicio).set('dataFim', filtro.dataFim).set('status', filtro.status)
      .set('pagina', filtro.pagina).set('tamanhoPagina', filtro.tamanhoPagina);
    const headers = new HttpHeaders({
      'X-Objetivos-Token': localStorage.getItem('dashboard_objetivos_token') || '',
      'X-Skip-Loader': '1'
    });
    return this.http.get<LiberacoesLista>(this.baseUrl + 'api/DashboardLiberacoesFinanceiro', { params, headers });
  }
}
